export default __webpack_public_path__ + "static/media/the_brooklyn.7c3ad1dd.JPG";